import { create } from 'zustand';

type GlobalVolumeState = {
	volume: number;
	setVolume: (volume: number) => void;
	getVolume: () => number;
};

export const useGlobalVolumeStore = create<GlobalVolumeState>((set, get) => ({
	volume: 1,
	setVolume: (volume: number) => set({ volume }),
	getVolume: () => get().volume,
}));

export const useGlobalVolume = () => {
	const { getVolume, setVolume } = useGlobalVolumeStore();
	return { getVolume, setVolume };
};
